import { render } from "./SkinSlotB.vue?vue&type=template&id=7feb56ca&scoped=true&ts=true"
import script from "./SkinSlotB.vue?vue&type=script&lang=ts"
export * from "./SkinSlotB.vue?vue&type=script&lang=ts"

import "./SkinSlotB.vue?vue&type=style&index=0&id=7feb56ca&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7feb56ca"]])

export default __exports__